import { Box, Button, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";

// import AddModal from "./AddModal";
import {
  franchiseRequirenmentAdd,
  franchiseRequirenmentUpdate,
  getFranchiseRequirenment,
} from "../MyFranchise/franchiseAPI";
import ConfirmDelete from "../Jobs/confirmDelete";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function AddProduct({ setOpen }) {
  const struct = {
    // id: 4,
    title: "",
    territory: "",
    infrastructure: [],
    investmentCosts: [],
    royalties: [],
    staff: [],
  };
  //   const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [institute, setInstitute] = useState({ ...struct });
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getFranchiseRequirenment(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setInstitute({ ...struct, billerId });
        return;
      }
      setInstitute(obj);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };
  const handleDeleteEducation = (section, index) => {
    if (!section || index === null) return;
    const updatedEducation = institute[section]?.filter((_, i) => i !== index);

    setInstitute((prev) => ({
      ...prev,
      [section]: updatedEducation,
    }));

    franchiseRequirenmentUpdate({
      ...institute,
      [section]: updatedEducation,
    });
  };

  const handleSave = (data) => {
    if (!activeSection) return;

    setInstitute((prev) => ({
      ...prev,
      [activeSection]: [...(prev[activeSection] || []), { value: data.value }],
    }));
  };
  const handleUpdate = (data) => {
    if (editIndex === null || !activeSection) return;

    setInstitute((prev) => {
      const updatedArray = [...prev[activeSection]];
      updatedArray[editIndex] = {
        ...updatedArray[editIndex],
        value: data.value,
      };

      return {
        ...prev,
        [activeSection]: updatedArray,
      };
    });

    setEditIndex(null);
  };

  const submit = async () => {
    const payload = {
      ...institute,
    };
    if (!institute?.id) {
      await franchiseRequirenmentAdd(payload, () => {
        getData();
      });
    } else {
      await franchiseRequirenmentUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Grid container>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              "&:hover": {
                backgroundColor: "transparent", // removes hover background
              },
            }}
          >
            <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
          </IconButton>
          <Grid
            item
            xs={12}
            sm={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Add Product Details
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "0px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "70vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid container spacing={2} mb={1}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                id="title"
                size="small"
                label="Product Id"
                value={institute?.title}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    title: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                id="territory"
                label="Product Name"
                size="small"
                value={institute?.territory}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    territory: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid mb={1} item xs={12}>
            <Typography
              sx={{
                color: "#01008B",
                fontSize: {
                  xs: "13px",
                  sm: "16px",
                  md: "20px",
                },
                fontWeight: 500,
                mb: 1,
              }}
            >
              Consultant Business Discription
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={institute?.territory}
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  territory: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Button
              fullWidth
              variant="outlined"
              //   onClick={() => document.getElementById("imageUpload").click()}
              sx={{
                position: "relative",
                justifyContent: "center",
              }}
            >
              {/* Icon on the left */}
              <AddAPhotoOutlinedIcon
                sx={{
                  position: "absolute",
                  left: 16,
                }}
              />
              Attach image for display
            </Button>
          </Grid>

          {/* .Button */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* <AddModal
        open={open}
        handleClose={() => {
          setOpen(false);
          setEditIndex(null);
        }}
        activeSection={activeSection}
        onSave={(data) => {
          if (editIndex !== null) {
            handleUpdate(data); // UPDATE
          } else {
            handleSave(data); // ADD
          }
        }}
        editValue={
          editIndex !== null
            ? institute?.[activeSection]?.[editIndex]?.value
            : ""
        }
      /> */}
      <ConfirmDelete
        open={confirmOpen}
        title={
          `Do you want to remove ${deleteType} Detail?`
          // deleteType === "infrastructure"
          //   ? "Do you want to remove infrastructure Detail?"
          //   : "Do you want to remove Experience Detail?"
        }
        onClose={() => {
          setConfirmOpen(false);
          setDeleteIndex(null);
          setDeleteType("");
        }}
        onConfirm={() => {
          handleDeleteEducation(deleteType, deleteIndex);

          setConfirmOpen(false);
        }}
      />
    </Grid>
  );
}
